import Placeholder from "@tiptap/extension-placeholder";
import { blogExtensions } from "@/lib/blog-extensions";

// Zajednička blog šema + dodaci koji postoje samo u editoru.
export const blogEditorExtensions = [
  ...blogExtensions,
  Placeholder.configure({
    placeholder: "Počnite pisati svoj članak...",
  }),
];
